import React from 'react';
import PropTypes from 'prop-types';

import tournamentPrizesIcon from '../../../../images/tournament-prizes-icon.png';
import {useTranslation} from "@common/hooks/translation";

const TournamentPrizes = ({ tournament }) => {
  const t = useTranslation();

  return <div className="tournament-stats tournament-prizes">
    <div className="stats-top">
      <img src={tournamentPrizesIcon}/>
      <h2>{t('Prizes')}</h2>
    </div>
    <div className="stats-content">
      <div className="stats-content-inner">
        {tournament.PrizeStructure.map(item => <p key={item.PlaceNumber}>
          {t('Place')} - {item.PlaceNumber}

          <span className="stats-percent">{item.PrizePercent}%</span>
        </p>)}
      </div>
    </div>
  </div>
};

TournamentPrizes.propTypes = {
    tournament: PropTypes.object.isRequired,
};

export default TournamentPrizes;